import React from "react";
import { useRecoilValue } from "recoil";
import {
  bankbookFileState,
  firstReceiptFormState,
  signFileState,
} from "../../../recoil/receipt";
import Button from "../../atoms/buttons/Button";
import ButtonGroup from "../../atoms/layout/ButtonGroup";

const FooterButtonGroup = ({
  prevOnClick,
  nextOnClick,
  nextButtonType = "button",
  preSelect: preSelect,
  nextSelect: nextSelect,
}) => {
  // console.log("preSelect", preSelect);
  // console.log("nextSelect", nextSelect);
  return (
    <div className="base-sec-bottom">
      <ButtonGroup>
        <Button
          className="bottombtn bottombtn-w"
          size="lg"
          color="secondary"
          type="button"
          onClick={() => {
            prevOnClick();
          }}
        >
          {preSelect === "selected" ? "이전" : "취소"}
        </Button>
        <Button
          className="bottombtn bottombtn-b"
          size="lg"
          type={nextButtonType}
          onClick={
            nextButtonType !== "submit" &&
            function () {
              nextOnClick();
            }
          }
        >
          {nextSelect === "selected" ? "다음" : "확인"}
        </Button>
      </ButtonGroup>
    </div>
  );
};

export default FooterButtonGroup;
